import React from 'react'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import DashboardPageWithoutSideBar from 'organization/theme/DashboardPageWithoutSideBar'
import styled from 'styled-components'
import {useFormik} from 'formik'
import {handleAddressChange} from 'organization/Event/Settings'
import {CreateEventData} from 'organization/Event/CreateEventData'
import {useOrganization} from 'organization/providers/OrganizationProvider'
import {
  organizationEventRoutes,
  useOrganizationRoutes,
} from 'organization/OrganizationRoutes'
import {useLocalizedNavigate} from 'i18n/useLocalizedNavigate'
import {useI18n} from 'i18n/I18nContext'
import {DEFAULT_LOCALE, LOCALE_LABELS, SUPPORTED_LOCALES} from 'i18n/locales'

export const CreateEvent = () => {
  const {createEvent} = useOrganization()
  const navigate = useLocalizedNavigate()
  const routes = useOrganizationRoutes()
  const {t} = useI18n()
  const {handleSubmit, handleBlur, handleChange, values} = useFormik({
    initialValues: {
      name: '',
      slug: '',
      locale: DEFAULT_LOCALE,
    },
    onSubmit: async (values: CreateEventData) => {
      createEvent(values).then((event: any) => {
        if (event?.id) {
          navigate(organizationEventRoutes(event, routes).settings)
        }
      })
    },
  })

  return (
    <DashboardPageWithoutSideBar>
      <>
        <BreadcrumMenu title={t('createEvent.title')} />

        <div className="row">
          <div className="col-xxl-12">
            <div className="create__event-area">
              <div className="body__card-wrapper">
                {/* create event form  */}
                <form onSubmit={handleSubmit}>
                  <div className="create__event-main pt-25">
                    <div className="event__left-box">
                      <div className="create__input-wrapper">
                        <div className="singel__input-field mb-15">
                          <label className="input__field-text">
                            {t('createEvent.nameLabel')} <br />
                            <small>
                              <i>{t('createEvent.nameHint')}</i>
                            </small>
                          </label>
                          <input
                            type="text"
                            name="name"
                            placeholder={t('createEvent.namePlaceholder')}
                            defaultValue={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                          />
                        </div>

                        <div className="singel__input-field mb-15">
                          <label className="input__field-text">
                            {t('createEvent.slugLabel')} -{' '}
                            <AddressShow>{`www.eventa.tv/${values.slug}`}</AddressShow>{' '}
                            <br />
                            <small>
                              <i>{t('createEvent.slugHint')}</i>
                            </small>
                          </label>
                          <InputGroup>
                            <span>www.eventa.tv/</span>
                            <input
                              type="text"
                              name="slug"
                              placeholder={t('createEvent.slugPlaceholder')}
                              value={values.slug}
                              onChange={(e) => {
                                handleAddressChange(e, handleChange)
                              }}
                              onBlur={handleBlur}
                              required
                            />
                          </InputGroup>
                        </div>

                        <div className="singel__input-field mb-15">
                          <label className="input__field-text">
                            {t('createEvent.localeLabel')}
                          </label>
                          <select
                            name="locale"
                            className="form-select"
                            value={values.locale}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            {SUPPORTED_LOCALES.map((loc) => (
                              <option key={loc} value={loc}>
                                {LOCALE_LABELS[loc]}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="event__right-box">
                      <div className="pricing__item mb-30 mt-15">
                        <div className="pricing__item-header">
                          <div>
                            <span className="pricing__item-title">
                              {t('createEvent.ctaTitle')}
                            </span>
                          </div>
                        </div>
                        <div className="pricing__item-content">
                          <ul>
                            <li>
                              <i className="flaticon-comment"></i>{' '}
                              {t('createEvent.feature1')}
                            </li>
                            <li>
                              <i className="flaticon-comment"></i>{' '}
                              {t('createEvent.feature2')}
                            </li>
                            <li>
                              <i className="flaticon-comment"></i>{' '}
                              {t('createEvent.feature3')}
                            </li>
                            <li>
                              <i className="flaticon-comment"></i>{' '}
                              {t('createEvent.feature4')}
                            </li>
                            <li>
                              <i className="flaticon-comment"></i>{' '}
                              {t('createEvent.feature5')}
                            </li>
                          </ul>
                        </div>
                        <div className="pricing__btn-wrap">
                          <button className="input__btn w-100" type="submit">
                            {t('createEvent.submit')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    </DashboardPageWithoutSideBar>
  )
}

const InputGroup = styled.div`
  display: flex;

  & > span {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 15px;
    border: 1px solid var(--clr-border-4);
    border-radius: 4px;
    border-right: none;
  }
`
const AddressShow = styled.span`
  color: blue;
  cursor: pointer;
`
